import { render, staticRenderFns } from "./about-us-main-page.html?vue&type=template&id=3bd47d6a&scoped=true&external"
import script from "./about-us-main-page.js?vue&type=script&lang=js&external"
export * from "./about-us-main-page.js?vue&type=script&lang=js&external"
import style0 from "./about-us-main-page.scss?vue&type=style&index=0&id=3bd47d6a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd47d6a",
  null
  
)

export default component.exports